import { serializable, alias, primitive } from 'serializr';

export class Pagination {
	@serializable(alias('id', primitive()))
	id?: number;
}
